<template>
  <CritereBase :selected="selected" @select="(value) => $emit('select', value)">
    <SelectVarieteComponent
      label="Variété emblavée"
      :labelCols="{ md: '6' }"
      :fetch="true"
      :active="true"
      :value="params[1].valeur"
      @input="(value) => inputParam(1, value)"
    ></SelectVarieteComponent>
  </CritereBase>
</template>

<script>
import CritereBase from "./CritereBase.vue";
import SelectVarieteComponent from "../../inputs/SelectVarieteComponent.vue";
import { props, methods } from "./shared";
export default {
  name: "CritereVariete",
  components: { CritereBase, SelectVarieteComponent },
  props: { ...props, campagne: Number },
  watch: {
    campagne: function (newCampagne) {
      this.inputParam(0, newCampagne, false);
    },
  },
  mounted() {
    this.inputParam(0, this.campagne, false);
  },
  methods: { ...methods },
};
</script>
